import React from "react";

function TelegramIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      fill="none"
      viewBox="0 0 25 25"
    >
      <path
        fill="#00B0F2"
        d="M12.652.655h-.054C5.985.655.625 6.017.625 12.632v.054c0 6.614 5.36 11.976 11.973 11.976h.054c6.613 0 11.973-5.362 11.973-11.976v-.054c0-6.615-5.36-11.977-11.973-11.977z"
      ></path>
      <path
        fill="#FEFFFC"
        d="M5.17 12.25c.034-.018.068-.034.1-.049.57-.264 1.148-.511 1.725-.758.031 0 .083-.037.113-.048.044-.02.089-.038.133-.057l.257-.11.514-.22 1.026-.44 2.054-.879 2.055-.879 2.054-.879 2.054-.879c.152-.065.317-.163.48-.192.137-.024.27-.071.409-.097.261-.05.55-.07.8.038.087.038.167.091.233.158.318.314.273.83.206 1.273l-1.406 9.251c-.064.423-.151.888-.485 1.155-.283.226-.684.252-1.033.156-.35-.097-.657-.3-.959-.5l-3.757-2.487c-.297-.197-.629-.454-.625-.812.001-.215.13-.407.261-.577 1.088-1.42 2.658-2.396 3.826-3.75.165-.191.294-.536.068-.646-.134-.066-.29.024-.412.108l-4.63 3.218c-.504.35-1.032.71-1.64.796-.542.078-1.089-.074-1.614-.229-.441-.13-.88-.262-1.319-.4-.233-.072-.473-.15-.653-.314-.18-.164-.284-.44-.175-.658.068-.137.2-.224.339-.295l.001.001z"
      ></path>
    </svg>
  );
}

export default TelegramIcon;
